import { Injectable, Inject } from '@angular/core';

export class OrganisationDO {
	private id: Number;

	public companyName: String = null;

	private companyName1: String = null;

	public contactPersonName: String = null;

	private registrationNum: String = null;

	private industryCd: String = null;

	private numEmployees: String = null;


	public getId(): Number {
		return this.id;
	}

	public setId(id: Number): void {
		this.id = id;
	}


	public getCompanyName(): String {
		return this.companyName;
	}

	public setCompanyName(companyName: String) {
		this.companyName = companyName;
	}

	public getCompanyName1(): String {
		return this.companyName1;
	}

	public setCompanyName1(companyName1: String) {
		this.companyName1 = companyName1;
	}

	public getContactPersonName(): String {
		return this.contactPersonName;
	}

	public setContactPersonName(contactPersonName: String) {
		this.contactPersonName = contactPersonName;
	}

	public getRegistrationNum(): String {
		return this.registrationNum;
	}

	public setRegistrationNum(registrationNum: String) {
		this.registrationNum = registrationNum;
	}

	public getIndustryCd(): String {
		return this.industryCd;
	}

	public setIndustryCd(industryCd: String) {
		this.industryCd = industryCd;
	}

	public getNumEmployees(): String {
		return this.numEmployees;
	}

	public setNumEmployees(numEmployees: String) {
		this.numEmployees = numEmployees;
	}


	// public getSubChannelCd():String {
	// 	return this.subChannelCd;
	// }

	// public setSubChannelCd(subChannelCd:String) {
	// 	this.subChannelCd = subChannelCd;
	// }

	// public getDesignationCd():String {
	// 	return this.designationCd;
	// }

	// public setDesignationCd(designationCd:String) {
	// 	designationCd = designationCd;
	// }

	// public getLicenseNum():String {
	// 	return this.licenseNum;
	// }

	// public setLicenseNum(licenseNum:String) {
	// 	this.licenseNum = licenseNum;
	// }

	// public getLicenseExpiryDt():Date {
	// 	return this.licenseExpiryDt;
	// }

	// public setLicenseExpiryDt(licenseExpiryDt:Date) {
	// 	this.licenseExpiryDt = licenseExpiryDt;
	// }

	// public getLicenseIssueDt():Date {
	// 	return this.licenseIssueDt;
	// }

	// public setLicenseIssueDt(licenseIssueDt:Date) {
	// 	this.licenseIssueDt = licenseIssueDt;
	// }

	// public getCategoryCd():String{
	// 	return this.categoryCd;
	// }

	// public setCategoryCd(categoryCd:String) {
	// 	this.categoryCd = categoryCd;
	// }

	// public getPartnerCd():String {
	// 	return this.partnerCd;
	// }

	// public setPartnerCd(partnerCd:String) {
	// 	this.partnerCd = partnerCd;
	// }

	// public getPartnerbranchCd():String {
	// 	return this.partnerbranchCd;
	// }

	// public setPartnerbranchCd(partnerbranchCd:String) {
	// 	this.partnerbranchCd = partnerbranchCd;
	// }

	// public getClientRefGuid():String {
	// 	return this.clientRefGuid;
	// }

	// public setClientRefGuid(clientRefGuid:String) {
	// 	this.clientRefGuid = clientRefGuid;
	// }
	// public getObjectName():String {
	// 	return AgentDO.class.getSimpleName();
	// }
}
